/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectIndexingPublicError } from './projectIndexingPublicError';


/**
 * Authoritative progress of the latest full-indexing job. Processed is the number of completed documents and therefore includes failed documents; failed is the subset of processed documents that failed. The latest row is selected by created_at descending and id descending. Without a row, status, total, percentComplete, createdAt, startedAt, finishedAt, and publicError are null while processed and failed are 0. 
 */
export interface ProjectIndexingStatus { 
    /**
     * Null when no rag_index row exists; otherwise the current rag_index status.
     */
    status: ProjectIndexingStatus.StatusEnum | null;
    /**
     * Maps rag_index.progress_processed; 0 when no row exists.
     */
    processed: number;
    /**
     * Maps rag_index.progress_failed; 0 when no row exists.
     */
    failed: number;
    /**
     * Maps rag_index.progress_total; null when not determined or no row exists.
     */
    total: number | null;
    /**
     * processed / total * 100 when total is greater than 0; 100 when total is 0; null while total is unknown or no row exists. 
     */
    percentComplete: number | null;
    /**
     * Maps rag_index.created_at; null when no row exists.
     */
    createdAt: string | null;
    /**
     * Persisted timestamp of the atomic PENDING-to-RUNNING transition; null while PENDING or when no rag_index row exists. 
     */
    startedAt: string | null;
    /**
     * Maps rag_index.finished_at; null before a terminal state or when no row exists.
     */
    finishedAt: string | null;
    /**
     * Safe FAILED projection; null for every other state or when no row exists.
     */
    publicError: ProjectIndexingPublicError | null;
}
export namespace ProjectIndexingStatus {
    export const StatusEnum = {
        Pending: 'PENDING',
        Running: 'RUNNING',
        Active: 'ACTIVE',
        Failed: 'FAILED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


